import { render, staticRenderFns } from "./EducationalScheduleTimePlaceReportFilter.vue?vue&type=template&id=2163fc7e&"
import script from "./EducationalScheduleTimePlaceReportFilter.vue?vue&type=script&lang=js&"
export * from "./EducationalScheduleTimePlaceReportFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports